import React from 'react';

export default ({
    align,
    leadInSentence,
    quote
}) => (
        <div className="grid-container mb4 mt4">
            <div className={'row align--' + align}>
                <span className="db mb2 sans--small uppercase fw--700">{leadInSentence}</span>
                <p className="domaine--large italic">"{quote}"</p>
            </div>
        </div>
    );